<template>
  <div>
    <ModalComponent
      class="[&_.full-screen-modal-close-button]:!hidden [&_.dialogOverlay]:!opacity-0 [&_.dialogNotVisible]:translate-y-[50svh] [&_.dialogNotVisible]:!scale-100 [&_.dialogNotVisible]:!top-0 [&_.full-screen-modal-bg]:!bg-transparent"
      hashBase="location"
      ref="dialog"
      headerBg="#fff"
      keepContentAlive
    >
      <LocationSelector ref="selector" />
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '../utils/ModalComponentFullScreen.vue'
import LocationSelector from './LocationSelector.vue'

export default defineComponent({
  name: 'LocationSelectorDialog',
  components: { LocationSelector, ModalComponent },
  props: {},
  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('location_required', this.showDetails)
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showDetails() {
      setTimeout(() => {
        this.$refs.dialog.show()
        this.$refs.selector.initMap()
      }, 300)
    },
  },
  computed: {},
})
</script>
